import React, { Component } from 'react';
import { Link } from 'react-router';
import { Grid } from 'react-bootstrap';
import ProfileNav from './nav';
import i18n from 'kodyl-js/i18n/react';
import { connect } from 'react-redux';
import ErrorMessage from '../common/error-message';

@connect(({ auth: { user }, subscriptions }) => ({ user, subscriptions }))
@i18n
class Profile extends Component {
  render() {
    const { user, children } = this.props;

    let warning = null;
    if (user) {
      if (!user.email) {
        warning = {
          title: `${this.i18n('We need your email')}!`,
          text: this.i18n(
            'Or we wont be able to send you email notifications with new dwellings, matching your BoligAgent'
          )
        };
      } else if (!user.status) {
        warning = {
          title: `${this.i18n('Your email has not been verified')}!`,
          text: this.i18n(
            'You need to verify your email address, to be able to receive email notifications with new dwellings, matching your BoligAgent - see more under "%r"',
            <Link to="/profile">{this.i18n('Edit profile')}</Link>
          )
        };
      }
    }

    const slim =
      this.props.location.pathname === '/profile/subscription' &&
      !this.props.subscriptions.list.length;

    return (
      <Grid>
        {!slim ? (
          <div>
            {warning ? <ErrorMessage {...warning} /> : null}
            <ProfileNav />
            <br />
          </div>
        ) : null}

        {children}
      </Grid>
    );
  }
}

export default Profile;
